import { useInfiniteQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { ExtraTripsApprovalListSchema } from '@/constants/ApprovalConstants';
import api from '@/services/apiSgft';
import EmptyIcon from '../../assets/icons/empty.svg';
import { columns } from '../../constants/tableColumns/ExtraTripsFinishedApprovalsColumns';
import Spinner from '../atoms/Spinner';
import InfiniteTable from './InfiniteTable';

const ExtraTripsFinishedApprovalsTab = () => {
	const fetchApprovals = async ({ pageParam = 1 }) => {
		try {
			const response = await api.get('approval/extra-trip/solicitation', {
				params: {
					size: 20,
					page: pageParam,
					type: 'completed',
				},
			});
			const parsedData = ExtraTripsApprovalListSchema.parse(response.data);
			return parsedData;
		} catch (e) {
			toast.error('Erro ao carregar os dados', {
				theme: 'colored',
				toastId: 'error',
			});
			throw e;
		}
	};

	const { data, isLoading, fetchNextPage, isFetchingNextPage, hasNextPage } =
		useInfiniteQuery(['finished-extra-trip-approvals'], fetchApprovals, {
			getNextPageParam: (lastPage) => lastPage.nextPage,
		});

	const pendingApprovals =
		data?.pages.flatMap((page) => page.extraTripSolicitationData) ?? [];
	return (
		<div className="w-full px-2 pt-2">
			{isLoading ? (
				<div className="flex h-full w-full items-center rounded-md bg-white">
					<Spinner size={50} />
				</div>
			) : pendingApprovals.length > 0 ? (
				<InfiniteTable
					tableContainerClassName="max-h-full"
					hasNextPage={hasNextPage}
					data={pendingApprovals}
					columns={columns}
					fetchNextPage={fetchNextPage}
					isFetchingNextPage={isFetchingNextPage}
					alignTextLeft
				/>
			) : (
				<div className="flex w-full flex-col items-center justify-center py-10">
					<img src={EmptyIcon} className="w-40" alt="Empty icon" />
					<div className="flex flex-col items-center text-sm">
						<p>Nenhuma aprovação finalizada encontrada</p>
						<span className="font-semibold text-blue-800">
							Quando você fizer aprovações ou rejeições para idas extras, elas
							aparecerão aqui!
						</span>
					</div>
				</div>
			)}
		</div>
	);
};

export default ExtraTripsFinishedApprovalsTab;
